// extracted by mini-css-extract-plugin
module.exports = {"banner":"consent_banner_banner__3mMqd","inner":"consent_banner_inner__3b9Go","actions":"consent_banner_actions__ZFvAU"};